import { useTranslation } from "react-i18next";
import { TableHeaderWrapper } from "../../../components/common/Common.styles";
import ServerSideTableColumnHeader from "../../../components/common/table/ServerSideTableColumnHeader";
import { PaginatedData } from "../../../hooks/PaginationHooks";
import { AuditLogItem } from "../../../types/auditLogTypes";

interface AuditLogsTableheaderProps {
    paginatedData: PaginatedData<AuditLogItem>
}

export default function AuditLogsTableHeader({ paginatedData }: AuditLogsTableheaderProps) {
    const { t } = useTranslation();

    return (
        <TableHeaderWrapper>
            <ServerSideTableColumnHeader
                fieldName="timestamp"
                isSorted
                paginatedData={paginatedData}
                label={t("tableColumnHeaders.dateTime")}
                firstCol
                stickyFirstCol
            />
            <ServerSideTableColumnHeader
                fieldName="userName"
                isSorted
                paginatedData={paginatedData}
                label={t("tableColumnHeaders.executingUser")}
            />
            <ServerSideTableColumnHeader
                fieldName="type"
                isSorted
                paginatedData={paginatedData}
                label={t("tableColumnHeaders.action")}
            />
            <ServerSideTableColumnHeader
                fieldName="affectedUserName"
                isSorted
                paginatedData={paginatedData}
                label={t("tableColumnHeaders.affectedUser")}
            />
            <ServerSideTableColumnHeader
                fieldName="affectedUserIsDeleted"
                isSorted
                paginatedData={paginatedData}
                label={t("tableColumnHeaders.affectedUserIsDeleted")}
            />
            <ServerSideTableColumnHeader
                fieldName="entityType"
                isSorted
                paginatedData={paginatedData}
                label={t("tableColumnHeaders.entityType")}
            />
            <ServerSideTableColumnHeader
                fieldName="permissionName"
                isSorted
                paginatedData={paginatedData}
                label={t("tableColumnHeaders.permissionName")}
            />
            <ServerSideTableColumnHeader
                fieldName="actionModuleName"
                isSorted
                paginatedData={paginatedData}
                label={t("tableColumnHeaders.actionModuleName")}
            />
        </TableHeaderWrapper>
    );
};